module.exports = __webpack_public_path__ + "img/banner_2010.fe65db2e.png";